import initMK from '../_core/init.js';
import defineProp from '../_core/defineprop.js';
import addListener from './_addlistener.js';
import { listen, unlisten } from '../_dom/index.js';
import createDomEventHandler from './_createdomeventhandler.js';
import forEach from '../_helpers/foreach.js';
import findDomListeners from './_finddomlisteners.js';
import assign from '../_helpers/assign.js';
import { addOwner } from './_owners.js';
// returns an object with event handlers used at addDomListener
function createBindingHandlers(_ref) {
  var eventName = _ref.eventName,
    domEventHandler = _ref.domEventHandler,
    selector = _ref.selector;
  return {
    bindHandler: function bindHandler(_ref2) {
      var node = _ref2.node;
      listen(node, eventName, selector, domEventHandler);
    },
    unbindHandler: function unbindHandler(_ref3) {
      var node = _ref3.node;
      unlisten(node, eventName, selector, domEventHandler);
    }
  };
}
// adds DOM event listener for nodes bound to given property
// returns false when the same listener is already added
export default function addDomListener(object, key, eventName, selector, callback, context, info, name) {
  if (info === void 0) {
    info = {};
  }
  var def = initMK(object);
  var propDef = defineProp(object, key);
  var bindEventName = "_bind:" + key;
  var domEventData = {
    eventName: eventName,
    selector: selector,
    callback: callback,
    context: context
  };
  var _findDomListeners = findDomListeners(def.events[bindEventName], domEventData, true),
    existing = _findDomListeners[0];
  if (existing) {
    var _info$owner2;
    // the listener is kept until everyone who added it removes it
    var domEvent = existing.info.domEvent;
    forEach(def.events["_unbind:" + key], function (event) {
      var _info$owner;
      if (event.info.domEvent === domEvent) addOwner(event, (_info$owner = info.owner) != null ? _info$owner : null);
    });
    addOwner(existing, (_info$owner2 = info.owner) != null ? _info$owner2 : null);
    return false;
  }
  var domEventHandler = createDomEventHandler({
    key: key,
    object: object,
    callback: callback,
    context: context || object
  });
  var _createBindingHandler = createBindingHandlers({
      eventName: eventName,
      domEventHandler: domEventHandler,
      selector: selector
    }),
    bindHandler = _createBindingHandler.bindHandler,
    unbindHandler = _createBindingHandler.unbindHandler;
  // skipChecks: the listener is deduplicated above and fires addevent under its own name
  var domInfo = assign({}, info, {
    skipChecks: true,
    domEvent: assign({}, domEventData, {
      name: name || eventName + "::" + key + (selector ? "(" + selector + ")" : ''),
      domEventHandler: domEventHandler
    })
  });
  addListener(object, bindEventName, bindHandler, context, domInfo);
  addListener(object, "_unbind:" + key, unbindHandler, context, domInfo);
  var bindings = propDef.bindings;
  if (bindings) {
    forEach(bindings, function (_ref4) {
      var node = _ref4.node;
      return bindHandler({
        node: node
      });
    });
  }
  return true;
}